import { VulnSeverity } from '../../../../shared/issuesV2';
import type { VulnBadgeColor } from '../Badge/Badge';

/**
 * Maps the vuln severity to the badge color.
 */
export const severityToBadgeColor = (severity: string): VulnBadgeColor => {
  switch (severity) {
    case VulnSeverity.Critical:
      return 'critical-severity-vuln';
    case VulnSeverity.High:
      return 'high-severity-vuln';
    case VulnSeverity.Medium:
      return 'medium-severity-vuln';
    case VulnSeverity.Low:
      return 'low-severity-vuln';
    case VulnSeverity.Unknown:
    default:
      return 'unknown-severity-vuln';
  }
};
